export const getAppState = (state) => state.appState;

export const getAppLoading = (state) => state.appState.loading;

export const getAppViewMode = (state) => state.appState.viewMode;

export const getPreviousAppViewMode = (state) => state.appState.prevViewMode;
